export class ServerConfiguration {
    /* @ngInject */
    constructor($http, egUrlService) {
        this.$http = $http;
        this.egUrlService = egUrlService;
        this.environment = this.getEnvironment();
    }

    getEnvironment() {
        if (this.environment) {
            return this.environment;
        }
        var url = this.egUrlService.url('/authentication/serverConfiguration/environment');
        return this.$http.get(url).then(response => {
            return response.data;
        });
    }

}

